// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Models/AuthModels.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { User, UserRoles, userRolesFromJSON, userRolesToJSON } from "./AccountModels";

export const protobufPackage = "daisi.protos.v1";

export enum SystemRoles {
  SystemRolesHostDevice = 0,
  SystemRolesApp = 1,
  SystemRolesOrc = 2,
  SystemRolesUser = 3,
  UNRECOGNIZED = -1,
}

export function systemRolesFromJSON(object: any): SystemRoles {
  switch (object) {
    case 0:
    case "SystemRolesHostDevice":
      return SystemRoles.SystemRolesHostDevice;
    case 1:
    case "SystemRolesApp":
      return SystemRoles.SystemRolesApp;
    case 2:
    case "SystemRolesOrc":
      return SystemRoles.SystemRolesOrc;
    case 3:
    case "SystemRolesUser":
      return SystemRoles.SystemRolesUser;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SystemRoles.UNRECOGNIZED;
  }
}

export function systemRolesToJSON(object: SystemRoles): string {
  switch (object) {
    case SystemRoles.SystemRolesHostDevice:
      return "SystemRolesHostDevice";
    case SystemRoles.SystemRolesApp:
      return "SystemRolesApp";
    case SystemRoles.SystemRolesOrc:
      return "SystemRolesOrc";
    case SystemRoles.SystemRolesUser:
      return "SystemRolesUser";
    case SystemRoles.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Request for the Orc to create a new ClientKey */
export interface CreateClientKeyRequest {
  /** The secret key to use for the request */
  SecretKey: string;
  OwnerId: string;
  OwnerName: string;
  OwnerRole: SystemRoles;
  AccessToIds: string[];
}

export interface CreateClientKeyResponse {
  ClientKey: string;
  KeyExpiration?: Date | undefined;
  OwnerId: string;
}

export interface DeleteClientKeyRequest {
  ClientKey: string;
  SecretKey: string;
}

export interface DeleteClientKeyResponse {
  Success: boolean;
}

export interface ValidateClientKeyRequest {
  SecretKey: string;
  ClientKey: string;
}

export interface ValidateClientKeyResponse {
  IsValid: boolean;
  KeyExpiration?: Date | undefined;
  FailureReason: string;
  UserId?: string | undefined;
  UserName?: string | undefined;
  UserRole?: UserRoles | undefined;
  UserAccountId?: string | undefined;
}

export interface SendAuthCodeRequest {
  EmailOrPhone: string;
}

export interface SendAuthCodeResponse {
  Success: boolean;
  ErrorMessage: string;
}

export interface ValidateAuthCodeRequest {
  SecretKey: string;
  EmailOrPhone: string;
  AuthCode: string;
  AppId: string;
}

export interface ValidateAuthCodeResponse {
  Success: boolean;
  ErrorMessage: string;
  ClientKey: string;
  KeyExpiration?: Date | undefined;
  UserName: string;
  AccountName: string;
  AccountId: string;
  UserRole: UserRoles;
}

export interface GetAuthenticatedUserRequest {
}

export interface GetAuthenticatedUserResponse {
  User?: User | undefined;
}

function createBaseCreateClientKeyRequest(): CreateClientKeyRequest {
  return { SecretKey: "", OwnerId: "", OwnerName: "", OwnerRole: 0, AccessToIds: [] };
}

export const CreateClientKeyRequest: MessageFns<CreateClientKeyRequest> = {
  encode(message: CreateClientKeyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.SecretKey !== "") {
      writer.uint32(10).string(message.SecretKey);
    }
    if (message.OwnerId !== "") {
      writer.uint32(18).string(message.OwnerId);
    }
    if (message.OwnerName !== "") {
      writer.uint32(26).string(message.OwnerName);
    }
    if (message.OwnerRole !== 0) {
      writer.uint32(32).int32(message.OwnerRole);
    }
    for (const v of message.AccessToIds) {
      writer.uint32(42).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateClientKeyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateClientKeyRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.SecretKey = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.OwnerId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.OwnerName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.OwnerRole = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.AccessToIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateClientKeyRequest {
    return {
      SecretKey: isSet(object.SecretKey) ? globalThis.String(object.SecretKey) : "",
      OwnerId: isSet(object.OwnerId) ? globalThis.String(object.OwnerId) : "",
      OwnerName: isSet(object.OwnerName) ? globalThis.String(object.OwnerName) : "",
      OwnerRole: isSet(object.OwnerRole) ? systemRolesFromJSON(object.OwnerRole) : 0,
      AccessToIds: globalThis.Array.isArray(object?.AccessToIds)
        ? object.AccessToIds.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: CreateClientKeyRequest): unknown {
    const obj: any = {};
    if (message.SecretKey !== "") {
      obj.SecretKey = message.SecretKey;
    }
    if (message.OwnerId !== "") {
      obj.OwnerId = message.OwnerId;
    }
    if (message.OwnerName !== "") {
      obj.OwnerName = message.OwnerName;
    }
    if (message.OwnerRole !== 0) {
      obj.OwnerRole = systemRolesToJSON(message.OwnerRole);
    }
    if (message.AccessToIds?.length) {
      obj.AccessToIds = message.AccessToIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateClientKeyRequest>, I>>(base?: I): CreateClientKeyRequest {
    return CreateClientKeyRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateClientKeyRequest>, I>>(object: I): CreateClientKeyRequest {
    const message = createBaseCreateClientKeyRequest();
    message.SecretKey = object.SecretKey ?? "";
    message.OwnerId = object.OwnerId ?? "";
    message.OwnerName = object.OwnerName ?? "";
    message.OwnerRole = object.OwnerRole ?? 0;
    message.AccessToIds = object.AccessToIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseCreateClientKeyResponse(): CreateClientKeyResponse {
  return { ClientKey: "", KeyExpiration: undefined, OwnerId: "" };
}

export const CreateClientKeyResponse: MessageFns<CreateClientKeyResponse> = {
  encode(message: CreateClientKeyResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ClientKey !== "") {
      writer.uint32(10).string(message.ClientKey);
    }
    if (message.KeyExpiration !== undefined) {
      Timestamp.encode(toTimestamp(message.KeyExpiration), writer.uint32(18).fork()).join();
    }
    if (message.OwnerId !== "") {
      writer.uint32(26).string(message.OwnerId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateClientKeyResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateClientKeyResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ClientKey = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.KeyExpiration = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.OwnerId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateClientKeyResponse {
    return {
      ClientKey: isSet(object.ClientKey) ? globalThis.String(object.ClientKey) : "",
      KeyExpiration: isSet(object.KeyExpiration) ? fromJsonTimestamp(object.KeyExpiration) : undefined,
      OwnerId: isSet(object.OwnerId) ? globalThis.String(object.OwnerId) : "",
    };
  },

  toJSON(message: CreateClientKeyResponse): unknown {
    const obj: any = {};
    if (message.ClientKey !== "") {
      obj.ClientKey = message.ClientKey;
    }
    if (message.KeyExpiration !== undefined) {
      obj.KeyExpiration = message.KeyExpiration.toISOString();
    }
    if (message.OwnerId !== "") {
      obj.OwnerId = message.OwnerId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateClientKeyResponse>, I>>(base?: I): CreateClientKeyResponse {
    return CreateClientKeyResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateClientKeyResponse>, I>>(object: I): CreateClientKeyResponse {
    const message = createBaseCreateClientKeyResponse();
    message.ClientKey = object.ClientKey ?? "";
    message.KeyExpiration = object.KeyExpiration ?? undefined;
    message.OwnerId = object.OwnerId ?? "";
    return message;
  },
};

function createBaseDeleteClientKeyRequest(): DeleteClientKeyRequest {
  return { ClientKey: "", SecretKey: "" };
}

export const DeleteClientKeyRequest: MessageFns<DeleteClientKeyRequest> = {
  encode(message: DeleteClientKeyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ClientKey !== "") {
      writer.uint32(10).string(message.ClientKey);
    }
    if (message.SecretKey !== "") {
      writer.uint32(18).string(message.SecretKey);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteClientKeyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteClientKeyRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ClientKey = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.SecretKey = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteClientKeyRequest {
    return {
      ClientKey: isSet(object.ClientKey) ? globalThis.String(object.ClientKey) : "",
      SecretKey: isSet(object.SecretKey) ? globalThis.String(object.SecretKey) : "",
    };
  },

  toJSON(message: DeleteClientKeyRequest): unknown {
    const obj: any = {};
    if (message.ClientKey !== "") {
      obj.ClientKey = message.ClientKey;
    }
    if (message.SecretKey !== "") {
      obj.SecretKey = message.SecretKey;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteClientKeyRequest>, I>>(base?: I): DeleteClientKeyRequest {
    return DeleteClientKeyRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteClientKeyRequest>, I>>(object: I): DeleteClientKeyRequest {
    const message = createBaseDeleteClientKeyRequest();
    message.ClientKey = object.ClientKey ?? "";
    message.SecretKey = object.SecretKey ?? "";
    return message;
  },
};

function createBaseDeleteClientKeyResponse(): DeleteClientKeyResponse {
  return { Success: false };
}

export const DeleteClientKeyResponse: MessageFns<DeleteClientKeyResponse> = {
  encode(message: DeleteClientKeyResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteClientKeyResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteClientKeyResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteClientKeyResponse {
    return { Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false };
  },

  toJSON(message: DeleteClientKeyResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteClientKeyResponse>, I>>(base?: I): DeleteClientKeyResponse {
    return DeleteClientKeyResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteClientKeyResponse>, I>>(object: I): DeleteClientKeyResponse {
    const message = createBaseDeleteClientKeyResponse();
    message.Success = object.Success ?? false;
    return message;
  },
};

function createBaseValidateClientKeyRequest(): ValidateClientKeyRequest {
  return { SecretKey: "", ClientKey: "" };
}

export const ValidateClientKeyRequest: MessageFns<ValidateClientKeyRequest> = {
  encode(message: ValidateClientKeyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.SecretKey !== "") {
      writer.uint32(10).string(message.SecretKey);
    }
    if (message.ClientKey !== "") {
      writer.uint32(18).string(message.ClientKey);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ValidateClientKeyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidateClientKeyRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.SecretKey = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ClientKey = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ValidateClientKeyRequest {
    return {
      SecretKey: isSet(object.SecretKey) ? globalThis.String(object.SecretKey) : "",
      ClientKey: isSet(object.ClientKey) ? globalThis.String(object.ClientKey) : "",
    };
  },

  toJSON(message: ValidateClientKeyRequest): unknown {
    const obj: any = {};
    if (message.SecretKey !== "") {
      obj.SecretKey = message.SecretKey;
    }
    if (message.ClientKey !== "") {
      obj.ClientKey = message.ClientKey;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ValidateClientKeyRequest>, I>>(base?: I): ValidateClientKeyRequest {
    return ValidateClientKeyRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ValidateClientKeyRequest>, I>>(object: I): ValidateClientKeyRequest {
    const message = createBaseValidateClientKeyRequest();
    message.SecretKey = object.SecretKey ?? "";
    message.ClientKey = object.ClientKey ?? "";
    return message;
  },
};

function createBaseValidateClientKeyResponse(): ValidateClientKeyResponse {
  return {
    IsValid: false,
    KeyExpiration: undefined,
    FailureReason: "",
    UserId: undefined,
    UserName: undefined,
    UserRole: undefined,
    UserAccountId: undefined,
  };
}

export const ValidateClientKeyResponse: MessageFns<ValidateClientKeyResponse> = {
  encode(message: ValidateClientKeyResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.IsValid !== false) {
      writer.uint32(8).bool(message.IsValid);
    }
    if (message.KeyExpiration !== undefined) {
      Timestamp.encode(toTimestamp(message.KeyExpiration), writer.uint32(18).fork()).join();
    }
    if (message.FailureReason !== "") {
      writer.uint32(26).string(message.FailureReason);
    }
    if (message.UserId !== undefined) {
      writer.uint32(34).string(message.UserId);
    }
    if (message.UserName !== undefined) {
      writer.uint32(42).string(message.UserName);
    }
    if (message.UserRole !== undefined) {
      writer.uint32(48).int32(message.UserRole);
    }
    if (message.UserAccountId !== undefined) {
      writer.uint32(58).string(message.UserAccountId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ValidateClientKeyResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidateClientKeyResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.IsValid = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.KeyExpiration = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.FailureReason = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.UserId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.UserName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.UserRole = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.UserAccountId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ValidateClientKeyResponse {
    return {
      IsValid: isSet(object.IsValid) ? globalThis.Boolean(object.IsValid) : false,
      KeyExpiration: isSet(object.KeyExpiration) ? fromJsonTimestamp(object.KeyExpiration) : undefined,
      FailureReason: isSet(object.FailureReason) ? globalThis.String(object.FailureReason) : "",
      UserId: isSet(object.UserId) ? globalThis.String(object.UserId) : undefined,
      UserName: isSet(object.UserName) ? globalThis.String(object.UserName) : undefined,
      UserRole: isSet(object.UserRole) ? userRolesFromJSON(object.UserRole) : undefined,
      UserAccountId: isSet(object.UserAccountId) ? globalThis.String(object.UserAccountId) : undefined,
    };
  },

  toJSON(message: ValidateClientKeyResponse): unknown {
    const obj: any = {};
    if (message.IsValid !== false) {
      obj.IsValid = message.IsValid;
    }
    if (message.KeyExpiration !== undefined) {
      obj.KeyExpiration = message.KeyExpiration.toISOString();
    }
    if (message.FailureReason !== "") {
      obj.FailureReason = message.FailureReason;
    }
    if (message.UserId !== undefined) {
      obj.UserId = message.UserId;
    }
    if (message.UserName !== undefined) {
      obj.UserName = message.UserName;
    }
    if (message.UserRole !== undefined) {
      obj.UserRole = userRolesToJSON(message.UserRole);
    }
    if (message.UserAccountId !== undefined) {
      obj.UserAccountId = message.UserAccountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ValidateClientKeyResponse>, I>>(base?: I): ValidateClientKeyResponse {
    return ValidateClientKeyResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ValidateClientKeyResponse>, I>>(object: I): ValidateClientKeyResponse {
    const message = createBaseValidateClientKeyResponse();
    message.IsValid = object.IsValid ?? false;
    message.KeyExpiration = object.KeyExpiration ?? undefined;
    message.FailureReason = object.FailureReason ?? "";
    message.UserId = object.UserId ?? undefined;
    message.UserName = object.UserName ?? undefined;
    message.UserRole = object.UserRole ?? undefined;
    message.UserAccountId = object.UserAccountId ?? undefined;
    return message;
  },
};

function createBaseSendAuthCodeRequest(): SendAuthCodeRequest {
  return { EmailOrPhone: "" };
}

export const SendAuthCodeRequest: MessageFns<SendAuthCodeRequest> = {
  encode(message: SendAuthCodeRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.EmailOrPhone !== "") {
      writer.uint32(10).string(message.EmailOrPhone);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SendAuthCodeRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendAuthCodeRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.EmailOrPhone = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SendAuthCodeRequest {
    return { EmailOrPhone: isSet(object.EmailOrPhone) ? globalThis.String(object.EmailOrPhone) : "" };
  },

  toJSON(message: SendAuthCodeRequest): unknown {
    const obj: any = {};
    if (message.EmailOrPhone !== "") {
      obj.EmailOrPhone = message.EmailOrPhone;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SendAuthCodeRequest>, I>>(base?: I): SendAuthCodeRequest {
    return SendAuthCodeRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SendAuthCodeRequest>, I>>(object: I): SendAuthCodeRequest {
    const message = createBaseSendAuthCodeRequest();
    message.EmailOrPhone = object.EmailOrPhone ?? "";
    return message;
  },
};

function createBaseSendAuthCodeResponse(): SendAuthCodeResponse {
  return { Success: false, ErrorMessage: "" };
}

export const SendAuthCodeResponse: MessageFns<SendAuthCodeResponse> = {
  encode(message: SendAuthCodeResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.ErrorMessage !== "") {
      writer.uint32(18).string(message.ErrorMessage);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SendAuthCodeResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendAuthCodeResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ErrorMessage = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SendAuthCodeResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      ErrorMessage: isSet(object.ErrorMessage) ? globalThis.String(object.ErrorMessage) : "",
    };
  },

  toJSON(message: SendAuthCodeResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.ErrorMessage !== "") {
      obj.ErrorMessage = message.ErrorMessage;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SendAuthCodeResponse>, I>>(base?: I): SendAuthCodeResponse {
    return SendAuthCodeResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SendAuthCodeResponse>, I>>(object: I): SendAuthCodeResponse {
    const message = createBaseSendAuthCodeResponse();
    message.Success = object.Success ?? false;
    message.ErrorMessage = object.ErrorMessage ?? "";
    return message;
  },
};

function createBaseValidateAuthCodeRequest(): ValidateAuthCodeRequest {
  return { SecretKey: "", EmailOrPhone: "", AuthCode: "", AppId: "" };
}

export const ValidateAuthCodeRequest: MessageFns<ValidateAuthCodeRequest> = {
  encode(message: ValidateAuthCodeRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.SecretKey !== "") {
      writer.uint32(10).string(message.SecretKey);
    }
    if (message.EmailOrPhone !== "") {
      writer.uint32(18).string(message.EmailOrPhone);
    }
    if (message.AuthCode !== "") {
      writer.uint32(26).string(message.AuthCode);
    }
    if (message.AppId !== "") {
      writer.uint32(34).string(message.AppId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ValidateAuthCodeRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidateAuthCodeRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.SecretKey = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.EmailOrPhone = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.AuthCode = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.AppId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ValidateAuthCodeRequest {
    return {
      SecretKey: isSet(object.SecretKey) ? globalThis.String(object.SecretKey) : "",
      EmailOrPhone: isSet(object.EmailOrPhone) ? globalThis.String(object.EmailOrPhone) : "",
      AuthCode: isSet(object.AuthCode) ? globalThis.String(object.AuthCode) : "",
      AppId: isSet(object.AppId) ? globalThis.String(object.AppId) : "",
    };
  },

  toJSON(message: ValidateAuthCodeRequest): unknown {
    const obj: any = {};
    if (message.SecretKey !== "") {
      obj.SecretKey = message.SecretKey;
    }
    if (message.EmailOrPhone !== "") {
      obj.EmailOrPhone = message.EmailOrPhone;
    }
    if (message.AuthCode !== "") {
      obj.AuthCode = message.AuthCode;
    }
    if (message.AppId !== "") {
      obj.AppId = message.AppId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ValidateAuthCodeRequest>, I>>(base?: I): ValidateAuthCodeRequest {
    return ValidateAuthCodeRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ValidateAuthCodeRequest>, I>>(object: I): ValidateAuthCodeRequest {
    const message = createBaseValidateAuthCodeRequest();
    message.SecretKey = object.SecretKey ?? "";
    message.EmailOrPhone = object.EmailOrPhone ?? "";
    message.AuthCode = object.AuthCode ?? "";
    message.AppId = object.AppId ?? "";
    return message;
  },
};

function createBaseValidateAuthCodeResponse(): ValidateAuthCodeResponse {
  return {
    Success: false,
    ErrorMessage: "",
    ClientKey: "",
    KeyExpiration: undefined,
    UserName: "",
    AccountName: "",
    AccountId: "",
    UserRole: 0,
  };
}

export const ValidateAuthCodeResponse: MessageFns<ValidateAuthCodeResponse> = {
  encode(message: ValidateAuthCodeResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.ErrorMessage !== "") {
      writer.uint32(18).string(message.ErrorMessage);
    }
    if (message.ClientKey !== "") {
      writer.uint32(26).string(message.ClientKey);
    }
    if (message.KeyExpiration !== undefined) {
      Timestamp.encode(toTimestamp(message.KeyExpiration), writer.uint32(34).fork()).join();
    }
    if (message.UserName !== "") {
      writer.uint32(42).string(message.UserName);
    }
    if (message.AccountName !== "") {
      writer.uint32(50).string(message.AccountName);
    }
    if (message.AccountId !== "") {
      writer.uint32(58).string(message.AccountId);
    }
    if (message.UserRole !== 0) {
      writer.uint32(64).int32(message.UserRole);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ValidateAuthCodeResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidateAuthCodeResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ErrorMessage = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ClientKey = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.KeyExpiration = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.UserName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.AccountName = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.UserRole = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ValidateAuthCodeResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      ErrorMessage: isSet(object.ErrorMessage) ? globalThis.String(object.ErrorMessage) : "",
      ClientKey: isSet(object.ClientKey) ? globalThis.String(object.ClientKey) : "",
      KeyExpiration: isSet(object.KeyExpiration) ? fromJsonTimestamp(object.KeyExpiration) : undefined,
      UserName: isSet(object.UserName) ? globalThis.String(object.UserName) : "",
      AccountName: isSet(object.AccountName) ? globalThis.String(object.AccountName) : "",
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      UserRole: isSet(object.UserRole) ? userRolesFromJSON(object.UserRole) : 0,
    };
  },

  toJSON(message: ValidateAuthCodeResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.ErrorMessage !== "") {
      obj.ErrorMessage = message.ErrorMessage;
    }
    if (message.ClientKey !== "") {
      obj.ClientKey = message.ClientKey;
    }
    if (message.KeyExpiration !== undefined) {
      obj.KeyExpiration = message.KeyExpiration.toISOString();
    }
    if (message.UserName !== "") {
      obj.UserName = message.UserName;
    }
    if (message.AccountName !== "") {
      obj.AccountName = message.AccountName;
    }
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (message.UserRole !== 0) {
      obj.UserRole = userRolesToJSON(message.UserRole);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ValidateAuthCodeResponse>, I>>(base?: I): ValidateAuthCodeResponse {
    return ValidateAuthCodeResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ValidateAuthCodeResponse>, I>>(object: I): ValidateAuthCodeResponse {
    const message = createBaseValidateAuthCodeResponse();
    message.Success = object.Success ?? false;
    message.ErrorMessage = object.ErrorMessage ?? "";
    message.ClientKey = object.ClientKey ?? "";
    message.KeyExpiration = object.KeyExpiration ?? undefined;
    message.UserName = object.UserName ?? "";
    message.AccountName = object.AccountName ?? "";
    message.AccountId = object.AccountId ?? "";
    message.UserRole = object.UserRole ?? 0;
    return message;
  },
};

function createBaseGetAuthenticatedUserRequest(): GetAuthenticatedUserRequest {
  return {};
}

export const GetAuthenticatedUserRequest: MessageFns<GetAuthenticatedUserRequest> = {
  encode(_: GetAuthenticatedUserRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAuthenticatedUserRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAuthenticatedUserRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetAuthenticatedUserRequest {
    return {};
  },

  toJSON(_: GetAuthenticatedUserRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAuthenticatedUserRequest>, I>>(base?: I): GetAuthenticatedUserRequest {
    return GetAuthenticatedUserRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAuthenticatedUserRequest>, I>>(_: I): GetAuthenticatedUserRequest {
    const message = createBaseGetAuthenticatedUserRequest();
    return message;
  },
};

function createBaseGetAuthenticatedUserResponse(): GetAuthenticatedUserResponse {
  return { User: undefined };
}

export const GetAuthenticatedUserResponse: MessageFns<GetAuthenticatedUserResponse> = {
  encode(message: GetAuthenticatedUserResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.User !== undefined) {
      User.encode(message.User, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAuthenticatedUserResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAuthenticatedUserResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.User = User.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAuthenticatedUserResponse {
    return { User: isSet(object.User) ? User.fromJSON(object.User) : undefined };
  },

  toJSON(message: GetAuthenticatedUserResponse): unknown {
    const obj: any = {};
    if (message.User !== undefined) {
      obj.User = User.toJSON(message.User);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAuthenticatedUserResponse>, I>>(base?: I): GetAuthenticatedUserResponse {
    return GetAuthenticatedUserResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAuthenticatedUserResponse>, I>>(object: I): GetAuthenticatedUserResponse {
    const message = createBaseGetAuthenticatedUserResponse();
    message.User = (object.User !== undefined && object.User !== null) ? User.fromPartial(object.User) : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
